import { render, staticRenderFns } from "./ActApplyBtn.vue?vue&type=template&id=11482570"
import script from "./ActApplyBtn.vue?vue&type=script&lang=js"
export * from "./ActApplyBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports